import React, { useEffect } from 'react';

const ModalToast = ({ message, type, isVisible, onClose, duration = 4000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose, duration]);

  if (!isVisible || !message) return null;

  const getToastStyles = () => {
    const baseStyles = {
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '16px 24px',
      borderRadius: '12px',
      fontWeight: '600',
      fontSize: '15px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      minWidth: '320px',
      maxWidth: '420px',
      animation: 'slideDownBounce 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      cursor: 'pointer',
      textAlign: 'left',
      justifyContent: 'flex-start',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    };

    const typeStyles = {
      success: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        border: '1px solid rgba(16, 185, 129, 0.3)'
      },
      error: {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: 'white',
        border: '1px solid rgba(239, 68, 68, 0.3)'
      },
      info: {
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        color: 'white',
        border: '1px solid rgba(59, 130, 246, 0.3)'
      },
      warning: {
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        border: '1px solid rgba(245, 158, 11, 0.3)'
      }
    };

    return { ...baseStyles, ...typeStyles[type] };
  };

  const getIcon = () => {
    const icons = {
      success: <i className="fas fa-check" />,
      error: <i className="fas fa-times" />,
      info: <i className="fas fa-info-circle" />,
      warning: <i className="fas fa-exclamation-triangle" />
    };
    return icons[type] || <i className="fas fa-circle" />;
  };

  const getIconStyles = () => {
    const baseIconStyles = {
      fontSize: '18px',
      fontWeight: 'bold',
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
    };

    const iconTypeStyles = {
      success: {
        background: 'rgba(255, 255, 255, 0.25)',
        color: 'white',
        border: '2px solid rgba(255, 255, 255, 0.3)'
      },
      error: {
        background: 'rgba(255, 255, 255, 0.25)',
        color: 'white',
        border: '2px solid rgba(255, 255, 255, 0.3)'
      },
      info: {
        background: 'rgba(255, 255, 255, 0.25)',
        color: 'white',
        border: '2px solid rgba(255, 255, 255, 0.3)'
      },
      warning: {
        background: 'rgba(255, 255, 255, 0.25)',
        color: 'white',
        border: '2px solid rgba(255, 255, 255, 0.3)'
      }
    };

    return { ...baseIconStyles, ...iconTypeStyles[type] };
  };

  return (
    <>
      <style>
        {`
          @keyframes slideDownBounce {
            0% {
              transform: translateX(-50%) translateY(30px) scale(0.8);
              opacity: 0;
            }
            60% {
              transform: translateX(-50%) translateY(-5px) scale(1.05);
              opacity: 1;
            }
            100% {
              transform: translateX(-50%) translateY(0) scale(1);
              opacity: 1;
            }
          }
          
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
        `}
      </style>
      <div
        style={getToastStyles()}
        onClick={onClose}
      >
        <div style={getIconStyles()}>
          {getIcon()}
        </div>
        <span style={{ flex: 1 }}>{message}</span>
      </div>
    </>
  );
};

export default ModalToast;
